import { useEffect, useState } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FreeGiftModal from '@/pages/home/components/FreeGiftModal';
import AboutHero from './components/AboutHero';
import SistersIntro from './components/SistersIntro';
import OfferingsSection from './components/OfferingsSection';
import ThemesSection from './components/ThemesSection';
import AudienceSection from './components/AudienceSection';
import FAQSection from './components/FAQSection';
import { aboutFaqs } from '@/mocks/about';

const ABOUT_TITLE = "About Gracie & Lily Adventures | Magical Children's Books";
const ABOUT_DESCRIPTION =
  "Meet Gracie & Lily, the real Bichon Frise sisters behind magical personalized children's books for ages 3-8. Learn about our stories, values, and gifts.";
const ABOUT_KEYWORDS =
  "Gracie and Lily, children's books, personalized children's books, Bichon Frise, kids books ages 3-8, bedtime stories";

function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setPropertyMeta(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function injectJsonLd(id: string, data: object) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function About() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    document.title = ABOUT_TITLE;

    setMeta('description', ABOUT_DESCRIPTION);
    setMeta('keywords', ABOUT_KEYWORDS);

    setPropertyMeta('og:title', ABOUT_TITLE);
    setPropertyMeta('og:description', ABOUT_DESCRIPTION);
    setPropertyMeta('og:type', 'website');

    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) {
      canonical.setAttribute('href', 'https://gracieandlily.com/about/');
    }

    injectJsonLd('jsonld-faq', {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: aboutFaqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    });

    return () => {
      document.getElementById('jsonld-faq')?.remove();
    };
  }, []);

  return (
    <div className="w-full min-h-screen">
      <Navbar onOpenModal={() => setShowModal(true)} />
      <main>
        <AboutHero onOpenModal={() => setShowModal(true)} />
        <SistersIntro />
        <OfferingsSection />
        <ThemesSection />
        <AudienceSection />
        <FAQSection />
      </main>
      <Footer />
      <FreeGiftModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}